import React from "react";
import { isRouteErrorResponse, useLocation, useNavigate, useRouteError } from "react-router";
import BlankStateV2 from "@ui/BlankStateV2";
import Construction from "@ui/Picto/Construction";
import { useAuth } from "react-oidc-context";
import { ApiError, userMessage } from "../api/error";
import tui from "@ui/i18n";
import t from "../i18n";
import { toPath } from "./helpers/path";
import setDocumentTitle from "../lib/setDocumentTitle";

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    setDocumentTitle("Metroscope");
  }, []);

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <BlankStateV2
        url={location.pathname}
        title={tui("404.title", location.pathname)}
        subtitle={tui("404.description")}
        onClick={() => navigate(toPath("/", {}))}
        buttonLabel={tui("404.action")}
      />
    );
  }

  const [title, subtitle] =
    error instanceof Error
      ? [userMessage(error), error.message]
      : typeof error === "string"
        ? [error, null]
        : ["Unknown error", null];

  const buttonText =
    error instanceof ApiError && error.type === "unauthorized"
      ? t("fallback.reconnect")
      : t("fallback.retry");

  const handleButtonClick = () => {
    if (error instanceof ApiError) {
      switch (error.type) {
        case "unauthorized": {
          void auth.signinRedirect({
            redirect_uri: window.location.href,
          });
          break;
        }
        case "conflict":
        case "bad_request":
        case "not_found":
        case "contract_failure":
        case "backend_error":
        case "tmp_backend_error":
        case "network": {
          window.location.reload();
          break;
        }
        default: {
          //   const n: never = error.type;
          throw error.type;
        }
      }
    } else {
      window.location.reload();
    }
  };

  return (
    <BlankStateV2
      picto={<Construction />}
      title={title}
      subtitle={subtitle}
      onClick={() => handleButtonClick()}
      buttonLabel={buttonText}
      //disabled={retryDisabled}
    />
  );
};
